/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import {InputAdornment } from '@mui/material';
import {CleanIcon, EmailSubsectionChip} from "../../../components/buttons/IconButtons";
import { permissionObj } from '../../../Helpers/permission';
import EmailSettingApp from "./EmailSetting/EmailSettingApp";
import HeadTittle from "../../../components/HeadTittle";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {EditIcon} from "../../../components/buttons/IconButtons";
import DivContainerBody from "../../../components/DivContainerBody";
import DividerWithText from "../../../components/DividerWithText";
import {CustomTextField} from "../../../components/CustomTextField";
import {CustomPassword} from "../../../components/CustomPassword";
import ButtonIcon from '../../../components/buttons/ButtonIcon';

// Email Setting module main funtion
const EmailSetting = () => {
    const {
        t,
        DEV,
        permission,
        emptyFields,
        settings,
        setSettings,
        isValidEmail,
        handleEmailChange,
        handelEmailSettingUpdate,
        clearAllState,
    } = EmailSettingApp();

    return (
        <>
            <HeadTittle name={'email_settings'}>
                {(DEV || permission?.includes(permissionObj?.WEB_EMAIL_SETTINGS_UPDATE)) && (
                    <ButtonAction
                        id={"btn_es_update"}
                        name={"update"}
                        className={"btn-icon-edit"}
                        onClick={handelEmailSettingUpdate}
                        Icon={EditIcon}
                    />
                )}
            </HeadTittle>
            <DivContainerBody>
                <div className={'row'}>
                    <div className={'col-12 mt-4 mb-4'}>
                        <DividerWithText title={t('sender')} />
                        <div className="d-flex justify-content-end align-items-center w-100">
                            {(DEV || permission?.includes(permissionObj?.WEB_EMAIL_SETTINGS_UPDATE)) && (
                                <ButtonIcon
                                    id='btn_es_clean'
                                    Icon={CleanIcon}
                                    onClick={clearAllState}
                                    className='btn-clean-secondary-600'
                                    title={'clear_instances'}
                                    iconProps={'btn-icon-svg-12px icon-color-general-00'}
                                />
                            )}
                         </div>
                    </div>
                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomTextField id={"txt_es_email"}
                                         length={128}
                                         name={"email"}
                                         value={settings.email}
                                         trans={"email"}
                                         type={"text"}
                                         onChange={(e) => {
                                             setSettings((prevData) => ({
                                                 ...prevData,
                                                 email: e.target.value,
                                             }));
                                             handleEmailChange(e);
                                         }}
                                         emptyFields={emptyFields}
                                         required={true}
                                         disabled={!(DEV || permission?.includes(permissionObj?.WEB_EMAIL_SETTINGS_UPDATE))}
                                         isValid={isValidEmail}
                                         isValidText={"email_format_invalid"}
                                         InputProps={{
                                             endAdornment: (
                                                 <InputAdornment position='end'>
                                                     <EmailSubsectionChip className={'w-h-24px'} />
                                                 </InputAdornment>
                                             ),
                                         }}
                        />
                    </div>
                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomPassword id={"txt_es_password"}
                                        name="password"
                                        length={64}
                                        value={settings.password}
                                        onChange={(e) => {
                                            setSettings((prevData) => ({
                                                ...prevData,
                                                password: e.target.value,
                                            }));
                                        }}
                                        label={"password"}
                                        required={true}
                                        emptyFields={emptyFields}
                                        disabled={!(DEV || permission?.includes(permissionObj?.WEB_EMAIL_SETTINGS_UPDATE))}
                        />
                    </div>
                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomTextField id={"txt_es_imap_host"}
                                         length={128}
                                         name={"imapHost"}
                                         value={settings.imapHost}
                                         trans={"imap_host"}
                                         type={"text"}
                                         onChange={(e) => {
                                             setSettings((prevData) => ({
                                                 ...prevData,
                                                 imapHost: e.target.value,
                                             }));
                                         }}
                                         emptyFields={emptyFields}
                                         required={true}
                                         disabled={!(DEV || permission?.includes(permissionObj?.WEB_EMAIL_SETTINGS_UPDATE))}
                        />
                    </div>
                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomTextField id={"txt_es_port"}
                                         length={7}
                                         name={"port"}
                                         value={settings.port}
                                         trans={"port"}
                                         type={"number"}
                                         onChange={(e) => {
                                             setSettings((prevData) => ({
                                                 ...prevData,
                                                 port: e.target.value,
                                             }));
                                         }}
                                         emptyFields={emptyFields}
                                         required={true}
                                         disabled={!(DEV || permission?.includes(permissionObj?.WEB_EMAIL_SETTINGS_UPDATE))}

                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default EmailSetting;
